import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { AdminAuthService } from "@/service/api/admin-auth";
import { VerifyFirstAccessCodeDto } from "@/service/dto/admin-auth";

const useVerifyFirstAccessCode = () => {
  return useMutation({
    mutationFn: (data: VerifyFirstAccessCodeDto) => AdminAuthService.verifyFirstAccessCode(data),
    onError: () => {
      toast.error("Código inválido ou expirado. Verifique e tente novamente.", { toastId: "verify_first_access_code_error" });
    },
  });
};

export default useVerifyFirstAccessCode;
